import { EOptionMenuDocumentViewCallback } from '@/options-menu/types/enums/option-menu-item-callback';
import { IOptionMenuItem } from '@/options-menu/types/option-menu-item';

export class DocumentViewConstants {
  static availableOptions: IOptionMenuItem[] = [
    {
      icon: 'preview',
      title: 'preview',
      callback: EOptionMenuDocumentViewCallback.Preview,
      index: 1,
    },
    {
      icon: 'update-expiration',
      title: 'update-expiration',
      callback: EOptionMenuDocumentViewCallback.UpdateExpiration,
      preventFillIcon: true,
      index: 2,
    },
    {
      icon: 'update-deal-value',
      title: 'update-deal-value',
      callback: EOptionMenuDocumentViewCallback.UpdateDealValue,
      preventFillIcon: true,
      index: 3,
    },
    {
      icon: 'user',
      title: 'change-document-owner',
      callback: EOptionMenuDocumentViewCallback.ChangeDocumentOwner,
      preventFillIcon: false,
      index: 4,
    },
    {
      icon: 'export-field-data',
      title: 'export-field-data',
      callback: EOptionMenuDocumentViewCallback.ExportFieldData,
      preventFillIcon: true,
      index: 5,
    },
    {
      icon: 'send-video-reminder',
      title: 'send-video-reminder',
      callback: EOptionMenuDocumentViewCallback.SendVideoReminder,
      preventFillIcon: true,
      index: 6,
    },
    {
      icon: 'send-reminder-email',
      title: 'send-reminder-email',
      callback: EOptionMenuDocumentViewCallback.SendReminderEmail,
      preventFillIcon: true,
      index: 7,
    },
    {
      icon: 'send-sms',
      title: 'send-sms-reminder',
      callback: EOptionMenuDocumentViewCallback.SendSMS,
      preventFillIcon: true,
      index: 8,
    },
    {
      icon: 'upcoming-activities',
      title: 'upcoming-activities',
      callback: EOptionMenuDocumentViewCallback.UpcomingActivities,
      preventFillIcon: true,
      index: 9,
    },
    {
      icon: 'add-new-recipient',
      title: 'add-new-recipient',
      callback: EOptionMenuDocumentViewCallback.AddNewRecipient,
      preventFillIcon: true,
      index: 10,
    },
    {
      icon: 'download',
      title: 'download',
      callback: EOptionMenuDocumentViewCallback.Download,
      preventFillIcon: false,
      index: 11,
    },
    {
      icon: 'upload-signed-document',
      title: 'upload-signed-document',
      callback: EOptionMenuDocumentViewCallback.UploadSignedDocument,
      preventFillIcon: true,
      index: 12,
    },
    {
      icon: 'mark-as-lost',
      title: 'mark-as-lost',
      callback: EOptionMenuDocumentViewCallback.MarkAsLost,
      preventFillIcon: true,
      index: 13,
    },
    {
      icon: 'flag-as-won',
      title: 'flag-as-won',
      callback: EOptionMenuDocumentViewCallback.FlagAsWon,
      preventFillIcon: true,
      index: 14,
    },
    {
      icon: 'remove-document',
      title: 'delete-document',
      callback: EOptionMenuDocumentViewCallback.RecallDeal,
      preventFillIcon: true,
      index: 15,
    },
    {
      icon: 'update-schedule',
      title: 'update-schedule',
      callback: EOptionMenuDocumentViewCallback.Reschedule,
      preventFillIcon: true,
      index: 16,
    },
    {
      icon: 'create-new-version',
      title: 'create-new-version',
      callback: EOptionMenuDocumentViewCallback.CreateNewVersion,
      preventFillIcon: true,
      index: 17,
    },
    {
      icon: 'remove-document',
      title: 'delete-document',
      callback: EOptionMenuDocumentViewCallback.DeleteDocument,
      preventFillIcon: true,
      index: 18,
    },
  ];
}
